import React from 'react';
import { useDocument } from '@nandorojo/swr-firestore';
import { CollectionPath, ImainhomeDoc } from '@typings/collections.enum';

import { ImainHome } from '@typings/setting/mainHome.interface';
import TitleWidgetSec from '../components/TitleWidgetSec';
import { MAIN_HOME_SEC_TYPE } from '@typings/setting/MainHomeSecType';
import BannerSec from './BannerSec';

function BoxBannerSec() {
  const { data: mainHomeData, set } = useDocument<ImainHome>(
    `${CollectionPath.MAINHOME}/${ImainhomeDoc.MAINHOME}`,
  );

  const bannerData = mainHomeData?.banner;
  const titleText = bannerData?.titleText || bannerData?.bannerCollapseText || '';
  const isBannerSectionBackground = bannerData?.sectionBackgroundSet ?? false;

  return (
    <>
      <TitleWidgetSec
        titleDesignType={mainHomeData?.titleDesignType}
        title={titleText}
        style={{ gridArea: MAIN_HOME_SEC_TYPE.BANNEER }}
        maxHeight="520px" // 배너 영역 고정 높이 확보 (내부 스크롤)
        mobileMaxHeight="400px"
        isBackground={isBannerSectionBackground}
      >
        <BannerSec isBannerCollapse={bannerData?.isBannerCollapse} />
      </TitleWidgetSec>
    </>
  );
}

export default BoxBannerSec;
